import { colorConst } from "@styles/common-colors";

// -------------------------------------------------- //
// Helper functions for common styling of UI elements //
// -------------------------------------------------- //

/** Returns pink style used for buttons in Developer mode. */
export function getDevButtonStyle(): {
  // One would like to use SxProps<Theme> as return type, but TypeScript then believes style?.backgroundColor
  // is not an allowed property.
  backgroundColor: string;
  "&:hover": {
      backgroundColor: string;
      filter: string;
  };
} {
  return {
    backgroundColor: colorConst.devFeature,
    "&:hover": {
      backgroundColor: colorConst.devFeature,
      filter: "brightness(90%)",
    },
  };
}
